import React from "react";

const AmbientBlobs = () => (
  <>
    <div className="mk-ambient a" aria-hidden="true" />
    <div className="mk-ambient b" aria-hidden="true" />
    <div className="mk-ambient c" aria-hidden="true" />
  </>
);

export default AmbientBlobs;
